import { render } from "./TextEditor.vue?vue&type=template&id=1c34ad37&scoped=true&ts=true"
import script from "./TextEditor.vue?vue&type=script&lang=ts"
export * from "./TextEditor.vue?vue&type=script&lang=ts"

import "./TextEditor.vue?vue&type=style&index=0&id=1c34ad37&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/test-saas-doctor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c34ad37"]])

export default __exports__